import { EntitleError } from "./entitleError";

export class AbortError extends EntitleError {
  constructor(message?: string, title?: string, suppressError = true) {
    super(message, title || undefined);
    this.name = "AbortError";
    this.suppressError = suppressError;
  }
}
